const LayoutConstants = {
  SideMenuWidth: 240,
};

export default LayoutConstants;
